var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card-body", attrs: { id: "#main-content" } },
    [
      _c(
        "ul",
        { staticClass: "list-group list-group-flush" },
        _vm._l(
          _vm.sortSubdomainsByCreatedAt(_vm.subdomains),
          function (applications, subdomain) {
            return _c(
              "li",
              { key: subdomain, staticClass: "list-group-item" },
              [
                _c(
                  "b-row",
                  {
                    staticClass:
                      "align-items-center sticky-interstitial-header",
                  },
                  [
                    _c("b-col", { attrs: { cols: "auto" } }, [
                      _c("div", { staticClass: "logo" }, [
                        _c("img", {
                          staticClass: "logo-img",
                          attrs: {
                            src: _vm._f("getLogo")(subdomain),
                            alt: _vm.$t("global.words.subdomain"),
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("b-col", [
                      _c("h6", { staticClass: "bold mb-0 sidetab-section" }, [
                        _vm._v("/" + _vm._s(subdomain)),
                      ]),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(
                  _vm.sortByCreatedAt(applications),
                  function (application) {
                    return _c(
                      "b-row",
                      {
                        key: application.applicationId,
                        staticClass:
                          "align-items-center select-application-row",
                        class: {
                          active:
                            _vm.selectedApplicationId ==
                            application.applicationId,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleSelectApplication(
                              application.applicationId,
                              subdomain
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "b-col",
                          {
                            attrs: {
                              md: "7",
                              cols: "12",
                              order: "2",
                              "order-md": "1",
                            },
                          },
                          [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "d-flex flex-row align-items-center justify-content-center",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "select-application-wrapper",
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-light select-application-button",
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-circle",
                                              attrs: { "aria-hidden": "true" },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "d-none" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "application-form.select"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass:
                                              "pl-2 d-flex align-items-center",
                                            attrs: { cols: "12" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "small text-primary bold",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "application.applicationID"
                                                      )
                                                    ) +
                                                    ":\n                    " +
                                                    _vm._s(
                                                      application.applicationId
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "badge status-badge complete ml-2 mb-0 my-auto bold",
                                                style: {
                                                  "background-color":
                                                    _vm.$options.filters.getSecondaryComplement(),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "getSchemaTranslation"
                                                      )(
                                                        _vm._f("getFlowTitle")(
                                                          application.applicationType,
                                                          _vm.flows
                                                        ),
                                                        _vm.translationMap
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "pl-0",
                                            attrs: { cols: "12" },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "small text-gray w-100 mb-0 regular-line-height px-2",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "bold" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "tables.columns.createdOn"
                                                        )
                                                      ) +
                                                        ":\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm._f("formatDateHour")(
                                                        application.createdAt
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "small text-capitalize",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      (" +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatTimeAgo"
                                                          )(
                                                            application.createdAt
                                                          )
                                                        ) +
                                                        ")\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "pl-0",
                                            attrs: { cols: "12" },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "small text-gray w-100 mb-0 regular-line-height px-2",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "bold" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "global.words.status"
                                                        )
                                                      ) +
                                                        ":\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm._f("textStatus")(
                                                        application.applicationStatus
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "pl-0",
                                            attrs: { cols: "12" },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "small text-gray w-100 mb-0 regular-line-height px-2",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "bold" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$tc(
                                                          "global.words.address",
                                                          1
                                                        )
                                                      ) +
                                                        ":\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      application.propertyAddress
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            attrs: {
                              md: "5",
                              cols: "12",
                              order: "1",
                              "order-md": "2",
                            },
                          },
                          [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "pr-0 d-md-block d-none",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _c("img", {
                                      staticClass:
                                        "img-fluid rounded-circle lg",
                                      attrs: {
                                        src: _vm._f("avatarPlaceholder")(
                                          application.agentDetails
                                        ),
                                        alt: "",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("b-col", [
                                  _c("h5", { staticClass: "bold m-0" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          application.agentDetails.givenName
                                        ) +
                                        "\n                " +
                                        _vm._s(
                                          application.agentDetails.familyName
                                        ) +
                                        "\n              "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    { staticClass: "bold text-truncate" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            application.agentDetails.email
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }
                ),
              ],
              2
            )
          }
        ),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }